import { render } from "./MyToast.vue?vue&type=template&id=5db24a92&ts=true"
import script from "./MyToast.vue?vue&type=script&lang=ts"
export * from "./MyToast.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__